export const FLAG_ENUM = {
  DAC: 'DAC',
  EMARSYS: 'EMARSYS',
  EMARSYS_WEB_PUSH: 'EMARSYS_WEB_PUSH',
  EMARSYS_CDP: 'EMARSYS_CDP',
  EMARSYS_SUBMIT_LEADS: 'EMARSYS_SUBMIT_LEADS',
  EMARSYS_PROMO: 'EMARSYS_PROMO',
  EMARSYS_PROMO_LIST: 'EMARSYS_PROMO_LIST',
  EMARSYS_PACKAGE_SERVICE_DETAIL: 'EMARSYS_PACKAGE_SERVICE_DETAIL',
  EMARSYS_NEW_CAR_PURCHASE_PDP: 'EMARSYS_NEW_CAR_PURCHASE_PDP',
  EMARSYS_NEW_CAR_PURCHASE_PLP: 'EMARSYS_NEW_CAR_PURCHASE_PLP',
  EMARSYS_COUPON_SERVICE_DETAIL: 'EMARSYS_COUPON_SERVICE_DETAIL',
  EMARSYS_CART: 'EMARSYS_CART',
  EMARSYS_ACCESSORIES_DETAIL: 'EMARSYS_ACCESSORIES_DETAIL',
  EMARSYS_SERVICE_TOYOTA: 'EMARSYS_SERVICE_TOYOTA',
  EMARSYS_SUKU_CADANG: 'EMARSYS_SUKU_CADANG',
  EMARSYS_PRODUCT_KNOWLEDGE_DETAIL: 'EMARSYS_PRODUCT_KNOWLEDGE_DETAIL',
  EMARSYS_PRODUCT_KNOWLEDGE_LIST: 'EMARSYS_PRODUCT_KNOWLEDGE_LIST',
  EMARSYS_NEWS_DETAIL: 'EMARSYS_NEWS_DETAIL',
  EMARSYS_NEWS_LIST: 'EMARSYS_NEWS_LIST',
  EMARSYS_LOGIN_REGISTER: 'EMARSYS_LOGIN_REGISTER',
  EMARSYS_HOME_PAGE: 'EMARSYS_HOME_PAGE',
  EMARSYS_BRANCH_SALES: 'EMARSYS_BRANCH_SALES',
  EMARSYS_GAMIFICATION: 'EMARSYS_GAMIFICATION',
  EMARSYS_BRANCH_SALES_SALES_ADVISOR: 'EMARSYS_BRANCH_SALES_SALES_ADVISOR',
};

export default function getFlagValue(flag: string) {
  switch (flag) {
    case FLAG_ENUM.DAC:
      return process.env.NEXT_PUBLIC_FLAG_DAC === 'true';
    case FLAG_ENUM.EMARSYS:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS === 'true';
    case FLAG_ENUM.EMARSYS_WEB_PUSH:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_WEB_PUSH === 'true';
    case FLAG_ENUM.EMARSYS_CDP:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_CDP === 'true';
    case FLAG_ENUM.EMARSYS_SUBMIT_LEADS:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_SUBMIT_LEADS === 'true';
    case FLAG_ENUM.EMARSYS_PROMO:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_PROMO === 'true';
    case FLAG_ENUM.EMARSYS_PROMO_LIST:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_PROMO_LIST === 'true';
    case FLAG_ENUM.EMARSYS_PACKAGE_SERVICE_DETAIL:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_PACKAGE_SERVICE_DETAIL === 'true';
    case FLAG_ENUM.EMARSYS_NEW_CAR_PURCHASE_PDP:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_NEW_CAR_PURCHASE_PDP === 'true';
    case FLAG_ENUM.EMARSYS_NEW_CAR_PURCHASE_PLP:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_NEW_CAR_PURCHASE_PLP === 'true';
    case FLAG_ENUM.EMARSYS_COUPON_SERVICE_DETAIL:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_COUPON_SERVICE_DETAIL === 'true';
    case FLAG_ENUM.EMARSYS_CART:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_CART === 'true';
    case FLAG_ENUM.EMARSYS_ACCESSORIES_DETAIL:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_ACCESSORIES_DETAIL === 'true';
    case FLAG_ENUM.EMARSYS_SERVICE_TOYOTA:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_SERVICE_TOYOTA === 'true';
    case FLAG_ENUM.EMARSYS_SUKU_CADANG:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_SUKU_CADANG === 'true';
    case FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_DETAIL:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_PRODUCT_KNOWLEDGE_DETAIL === 'true';
    case FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_LIST:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_PRODUCT_KNOWLEDGE_LIST === 'true';
    case FLAG_ENUM.EMARSYS_NEWS_DETAIL:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_NEWS_DETAIL === 'true';
    case FLAG_ENUM.EMARSYS_NEWS_LIST:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_NEWS_LIST === 'true';
    case FLAG_ENUM.EMARSYS_LOGIN_REGISTER:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_LOGIN_REGISTER === 'true';
    case FLAG_ENUM.EMARSYS_HOME_PAGE:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_HOME_PAGE === 'true';
    case FLAG_ENUM.EMARSYS_BRANCH_SALES:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_BRANCH_SALES === 'true';
    case FLAG_ENUM.EMARSYS_GAMIFICATION:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_GAMIFICATION === 'true';
    case FLAG_ENUM.EMARSYS_BRANCH_SALES_SALES_ADVISOR:
      return process.env.NEXT_PUBLIC_FLAG_EMARSYS_BRANCH_SALES_SALES_ADVISOR === 'true';
    default:
      return false;
  }
}
